import { strongFromEntries } from '@shady-pines/types';
import { isCollection } from '../types';
import type { Edge } from '../types';

export const flattenCollections = <T extends Record<string, unknown>>(edge: Edge<T>): T => {
  return strongFromEntries(
    Object.entries(edge.node).map((node) => {
      const [key, value] = node;
      if (!isCollection(key, value)) {
        return [key, value];
      }

      return [key, value.edges.map((e) => flattenCollections(e))];
    }),
  ) as T;
};
